import {Container, Nav, Navbar} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import '../../css/Header.css'
import {Link} from "react-router-dom";

const Header = ()=>{
    return(
        <>
            <Navbar bg="light" expand="lg">
                <Container className={'font-black'}>
                    <Navbar.Brand><Link to={'/'} className={'nav-text-title'}>
                        <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt={'logo'} width={60}/>
                        제주앙</Link></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className={'header-navbar'}>
                            <Link to={'/usage'} className={'nav-text'}>이용방법</Link>
                            <Link to={'/contents'} className={'nav-text'}>상품소개</Link>
                            <Link to={'/location'} className={'nav-text'}>오시는길</Link>
                            <Link to={'/faq'} className={'nav-text'}>FAQ</Link>
                            <Link to={'/reservation-popup'} className={'nav-text'}>예약확인</Link>
                            <Link to={'/cart'} className={'nav-text'}>장바구니</Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>

    );
}

export default Header
